import styled from 'styled-components';

import { getSpace, mq, getColor, getGridSpans } from '../../../../../stylesheets/tools';

const StyledWaitingLayer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  background: ${getColor('lightGray')};
  overflow-y: auto;
  z-index: 101;

  > div {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .container__wrapper {
    width: 100%;
  }

  .content {
    margin: ${getSpace('s')} auto;
    ${getGridSpans('width', { s: 12, m: 10, l: 8 })};
    text-align: center;

    ${mq('m')} {
      margin: ${getSpace('xxl')} auto;
    }
  }

  .robotarm {
    position: relative;
    ${getGridSpans('width', { s: 12, m: 6 })};
    margin-top: -10vh;
    z-index: -1;
  }

  .robotarm-wrapper {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 100%;

    img {
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  h2 {
    margin-bottom: ${getSpace('s')};

    ${mq('m')} {
      margin-bottom: ${getSpace('l')};
    }
  }

  p:last-of-type {
    margin-top: ${getSpace('xxs')};
  }

  .steps {
    svg {
      animation: showhide 5s infinite both;
      vertical-align: top;
      width: 27px;
      height: 62px;

      ${mq('m')} {
        width: 46px;
        height: 108px;
      }
    }

    svg:nth-child(even) {
      margin: ${getSpace('s')} 0 0 ${getSpace('xs')};
      transform: scale(-1, 1);

      ${mq('m')} {
        margin: ${getSpace('xl')} 0 0 ${getSpace('xs')};
      }
    }
  }

  p + .steps {
    display: none;

    ${mq('m')} {
      display: block;
    }
  }

  .steps:last-of-type {
    svg:first-child {
      animation-delay: 600ms;
    }
  }

  .steps:nth-last-of-type(2) {
    svg:first-child {
      animation-delay: 1.8s;
    }

    svg:last-child {
      animation-delay: 1.2s;
    }
  }

  .steps:nth-last-of-type(3) {
    svg:first-child {
      animation-delay: 3s;
    }

    svg:last-child {
      animation-delay: 2.4s;
    }
  }

  @keyframes showhide {
    0% {
      opacity: 0;
    }

    1% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }
`;

export default StyledWaitingLayer;
